module.exports = __webpack_public_path__ + "img/logo-white.c6e46153.svg";